// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"315":"ucare-panel-chunk","923":"ucare-widget-chunk"}[chunkId] || chunkId) + "." + {"273":"2afc8c26","315":"57ad6998","923":"017baff2"}[chunkId] + ".chunk.js";
};